/*
 * Lib Module Is
 */

Lib.Is = {
    string: function(check) {
        return typeof check === 'string';
    },
    int: function(check) {
        return this.Number(check);
    },
    number: function(check) {
        return typeof check === 'number';
    },
    empty: function(check) {

        // if its an array
        if (this.array(check)) {
            return (check.length === 0)
        }

        // if its an object
        if (this.object(check)) {
            return (Object.keys(check).length === 0);
        }

        // Anything else, check if its falsy
        return !check;
    },
    object: function(check) {
        return typeof check === 'object' && !this.array(check);
    },
    array: function(check) {
        return Array.isArray(check);
    }
};
